import React from "react";
import { Text, View } from "@react-pdf/renderer";

export const SingleDayColumn = props => {
  const { selectedDate, styles } = props;

  return (
    <View style={styles.border}>
      <View style={styles.product}>
        <Text style={styles.text}>
          Stock du {selectedDate}
        </Text>
      </View>
      <View style={styles.singleDay}>
        <Text style={styles.text}>{selectedDate}</Text>
      </View>
    </View>
  );
};
